import React from 'react';

interface IpadProps {
  color?: string;
  width?: number;
  height?: number;
  className?: string;
}

const Ipad = ({ color, width, height, className }: IpadProps) => (
  <svg
    viewBox="-5.69 0 31.3 31.3"
    width={width}
    height={height}
    className={className}
  >
    <path
      stroke={color || '#000000'}
      d="M17.73,0H2.19A2.19,2.19,0,0,0,0,2.19H0V29.11A2.19,2.19,0,0,0,2.19,31.3H17.73a2.19,2.19,0,0,0,2.19-2.19h0V2.19A2.19,2.19,0,0,0,17.73,0h0ZM10.06,29.82a1,1,0,1,1,1-1A1,1,0,0,1,10.06,29.82Zm8.13-3.28H1.73V3.76H18.18V26.54Z"
    />
  </svg>
);

export default Ipad;
